<template>
  <div class="physical">
    <!-- 遮罩层 -->
    <div class="mask"></div>
    <!--  情商语文-->
    <div class="item" v-show="status === 3">
      <div :class="['title', status === 3 ? 'animated fadeInUp' : '']">
        <div class="big">心田物理</div>
        <div class="small">悟出人生大道理</div>
      </div>
      <div :class="['con', status === 3 ? 'animated fadeInUp' : '']">
        心田物理秉持“深入浅出，触类旁通”的教学理念，将复杂的物理知识与日常生活有机结合，为学生建造一所充满趣味和智慧的知识殿堂，激发学生对自然科学的学习兴趣以及对宇宙奥秘的探索、求知欲望。我们的教学从生活中来，回到生活中去，培养学生解决难题的思维和策略、练就战胜难关的勇气和韧性，真正做到举一反三、学以致用，用物理来改变生活，让世界更加美好！
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["status"]
};
</script>
<style lang="less">
.physical {
  height: 100%;
  width: 100%;
  background: url(../../assets/images/physical.png) center no-repeat;
  position: relative;
  background-size: cover;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 1);
    opacity: 0.6;
    height: 100%;
    width: 100%;
    filter: alpha(opacity=60);
  }
  .item {
    position: relative;
    z-index: 2;
  }
  .title {
    animation-delay: 0.5s;
  }
  .big {
    font-size: 60px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    line-height: 102px;
    color: rgba(255, 255, 255, 1);
  }
  .small {
    font-size: 40px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 60px;
    color: rgba(204, 204, 204, 1);
    margin: 64px 0;
  }
  .con {
    animation-delay: 1s;
    width: 60%;
    font-size: 20px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 34px;
    color: rgba(204, 204, 204, 1);
    margin: auto;
  }
}
</style>
